// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__YDjSE","modal__close":"styles_modal__close__nhL8b","modal__buttons":"styles_modal__buttons__p9P1d"};